import React, { useState } from 'react';
import DateRange from '../molecules/DateRange'
import { Dropdown } from 'react-bootstrap';
import { Button } from "../../../components/buttons";

const CourierFilter = (props) => {
    const { title, data, loading, xAxisType, type, className, selectedCouriers }  = props;
    const [ selectAll, setSelectAll ] = useState(false) 
    const [ courierNames, setCourierNames ] = useState("")
    const [ couriers , setCouriers ] = useState([
        { courierName:"GRAB", courierCode:"grab", selected:false },
        { courierName:"GOJEK", courierCode:"gojek", selected:false },
        { courierName:"SiCepat", courierCode:"sicepat", selected:false },
        { courierName:"JNE", courierCode:"jne", selected:false },
        { courierName:"Jet Exress", courierCode:"jet", selected:false },
        { courierName:"Lion Parcel", courierCode:"lion", selected:false },
        { courierName:"Deliveree", courierCode:"deliveree", selected:false },
        { courierName:"MrSpeedy", courierCode:"mrspeedy", selected:false },
        { courierName:"Lalamove", courierCode:"lalamove", selected:false },
        { courierName:"Alfatrex", courierCode:"alfatrex", selected:false },
        { courierName:"RPX", courierCode:"rpx", selected:false },
        { courierName:"AnterAja", courierCode:"anteraja", selected:false },
        { courierName:"Ninja Express", courierCode:"ninja", selected:false },
        { courierName:"TIKI", courierCode:"tiki", selected:false },
        { courierName:"J&T", courierCode:"jnt", selected:false },
        { courierName:"Paxel", courierCode:"paxel", selected:false }
    ])
    
    const onClickCourier = (code) => {
        let copyCouriers = couriers;
        let objIndex = copyCouriers.findIndex(i => i.courierCode === code);
        copyCouriers[objIndex].selected = !copyCouriers[objIndex].selected;
        setCouriers(prev => ([...copyCouriers]));
        
        const filteredCouriers = copyCouriers.filter(i => i.selected )
        const arrayCouriers = filteredCouriers.reduce((r,i) => { r.push(i.courierCode); return r},[])
        
        selectedCouriers(arrayCouriers)
        setCourierNames(arrayCouriers.length)
    }

    const onSelectAllOption = () => {
        let copyCouriers = couriers;
        for (let i in copyCouriers ) {
            if (selectAll) {
                copyCouriers[i].selected = false;
            } else {
                copyCouriers[i].selected = true;
            }
        }
        const filteredCouriers = copyCouriers.filter(i => i.selected )
        setCourierNames(filteredCouriers.length)
        if (selectAll) {
            setSelectAll(false)
        } else {
            setSelectAll(true)
        }
    }


    return (
        <div>
            <Dropdown className="btn-group btn-group-sm">
              
                <div className="input-group input-group-sm">
                    <label>Pilih Kurir</label>
                <Dropdown.Toggle
                    id="dropdown-basic"
                    className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
                    {courierNames ? courierNames + " Kurir Terpilih" : "Pilih"} 
                </Dropdown.Toggle>
                </div>
             

                <Dropdown.Menu className="dropdown-menu-scroll p-4">
                    <label className="si si-checkbox d-flex align-items-center">
                        <input
                            className="mt-1"
                            onClick={() => onSelectAllOption()}
                            type="checkbox"
                            checked={selectAll}
                        />
                            <span 
                                className="si-label ml-3"
                                style={{marginTop:"-4px"}}
                            >
                            <b>Pilih Semua</b>
                            </span>
                    </label>
                    {
                        couriers.map((i,idx) => (
                            <label key={idx} className="si si-checkbox d-flex align-items-center">
                                <input
                                    className="mt-1"
                                    onClick={() => onClickCourier(i.courierCode)}
                                    type="checkbox"
                                    checked={i.selected}
                                    id={idx}
                                />
                                <span 
                                    className="si-label ml-3"
                                    style={{marginTop:"-4px"}}
                                >{i.courierName}</span>
                            </label>
                        ))
                    }
                    <Button
                        className="btn btn-sm btn-block btn-primary mr-3"
                        onClick={props.onClickFilter}
                    >
                    Filter Kurir
                    </Button>
                </Dropdown.Menu>
            </Dropdown> 
        </div>
    );
};

export default CourierFilter;
